/**
 * 내 자료 상세의 「나눔터에 공유」.
 * 진행 중에는 잠그고, 이미 공유된 자료는 「나눔터에서 보기」로 바꾼다.
 */

import React from 'react';
import { Spinner } from '../common/AsyncState';
import { GALLERY_SHARE_COPY } from '../../utils/galleryShareFeedback';

const ShareIcon = ({ color }) => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    <circle cx="18" cy="5" r="3" />
    <circle cx="6" cy="12" r="3" />
    <circle cx="18" cy="19" r="3" />
    <line x1="8.59" y1="13.51" x2="15.42" y2="17.49" />
    <line x1="15.41" y1="6.51" x2="8.59" y2="10.49" />
  </svg>
);

const ViewIcon = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#3182F6" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    <path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6" />
    <polyline points="15 3 21 3 21 9" />
    <line x1="10" y1="14" x2="21" y2="3" />
  </svg>
);

export default function LibraryShareToGalleryButton({
  className = 'gallery-detail-text-btn',
  galleryId = null,
  isShared = false,
  isSharing = false,
  onShare,
  onView,
}) {
  if (isShared) {
    const canOpen = typeof onView === 'function';
    if (!canOpen) {
      return (
        <span className={className} data-testid="library-share-to-gallery" style={{ color: '#9CA3AF', cursor: 'default' }}>
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#9CA3AF" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
            <polyline points="20,6 9,17 4,12" />
          </svg>
          {GALLERY_SHARE_COPY.shared}
        </span>
      );
    }
    return (
      <button
        className={className}
        data-testid="library-share-to-gallery"
        onClick={() => onView(galleryId)}
        style={{ color: '#3182F6' }}
        type="button"
      >
        <ViewIcon />
        {GALLERY_SHARE_COPY.viewButton}
      </button>
    );
  }

  return (
    <button
      aria-busy={isSharing || undefined}
      className={className}
      data-testid="library-share-to-gallery"
      disabled={isSharing}
      onClick={onShare}
      style={{ color: isSharing ? '#6B7280' : '#3182F6' }}
      type="button"
    >
      {isSharing ? (
        <Spinner className="gallery-detail-share-spinner" size={16} thickness={2} />
      ) : (
        <ShareIcon color="#3182F6" />
      )}
      {isSharing ? GALLERY_SHARE_COPY.sharing : GALLERY_SHARE_COPY.share}
    </button>
  );
}
